import { Box, Toolbar, Tooltip, Typography } from '@mui/material'
import Logo from '../../assets/logo.png';
import './Header.css';
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
 
 
 
const Header = (props) => {
  const location = useLocation();
  const { accounts,instance } = useMsal();
  const acct = instance.getActiveAccount() || accounts[0];
  const displayName =
    props?.userDetails?.userName ||
    localStorage.getItem("appUserName") ||
    acct?.name ||
    acct?.idTokenClaims?.name ||
    acct?.username ||
    acct?.idTokenClaims?.preferred_username ||
    acct?.idTokenClaims?.email ||
    localStorage.getItem("userName") || "";
  const userRole = props?.userDetails?.role || localStorage.getItem("appUserRole") || "";
  const cardTitle = localStorage.getItem("cardTitle");
  return (
    <div className="main-header" ref={props?.headerRef}>
      <Toolbar className='toolbar_header'>
        <div className="main-box">
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography sx={{ mr: 1, fontSize: '13px', color: '#ffffff' }}>{displayName}</Typography>
                  {userRole ? (
                    <Typography sx={{ mr: 1, fontSize: '11px', color: '#cfcfcf' }}>{userRole}</Typography>
                  ) : null}
                  {location?.pathname?.length > 3 && cardTitle && (
                    <div />
                  )}
                </Box>
 
                {location.pathname !== "/login" && (
                  <div>
                    <button onClick={props.handleLogout} className="logoutCustomButton">
                      Log Out
                    </button>
                  </div>
                )}
              </Box>
            </Tooltip>
          </Box>
        </div>
      </Toolbar>
 
 
 
 
 
 
      <div className='gradient_section'>
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {process.env.REACT_APP_ENV === "dev" ?
            "Development Environment - This is not Production. Use only for testing & development"
            : process.env.REACT_APP_ENV === "test" ?
              "UAT Environment - This is not Production. Use only for user acceptance testing"
              : process.env.REACT_APP_ENV === "uat" ?
                "UAT Environment - This is not Production. Use only for user acceptance testing"
                : process.env.REACT_APP_ENV === "prod" ?
                  ""
                  : ""}
        </span>
      </div>
    </div>
  );
}
 
export default Header